import { Component, Prop, Vue } from "vue-property-decorator";
import { getUserBranding } from "@/helpers/branding";

/**
 * Spinner de la app. En cuentas con marca propia reemplaza el gif de Cardinal
 * por el logo del cliente latiendo, para no mostrar la identidad de Cardinal
 * dentro de una app que para ese usuario ya no es de Cardinal.
 *
 * Registrado global en `main.ts`: es una primitiva usada en varias pantallas y
 * cargarla async mostraria un hueco antes de que aparezca el spinner.
 */
@Component({})
export default class Loader extends Vue {
  /** Ancho del gif en px. El logo de marca escala a partir de este valor. */
  @Prop({ default: 75 }) readonly size!: number;

  get brandLogo(): string | undefined {
    return getUserBranding(this.$store.state.user)?.logo;
  }

  get gifWidth(): string {
    return `${this.size}px`;
  }

  /** El logo de marca es apaisado: necesita mas ancho para leerse igual. */
  get brandWidth(): string {
    return `${Math.round(this.size * 1.75)}px`;
  }
}
